module.exports = __webpack_public_path__ + "static/media/new-york-81.5bfe97dd.jpg";